import { Link, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ProductCreateInput, ProductImageInput } from '@ncc/shared';
import { ProductForm, type ProductFormValues } from '../components/ProductForm';
import { api } from '../lib/api';

export function NewProduct() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const finalize = useMutation({
    mutationFn: async ({
      values,
      images,
    }: {
      values: ProductFormValues;
      images: ProductImageInput[];
    }) => {
      const payload = { ...values, images } as ProductCreateInput;
      return api.createProduct(payload);
    },
    onSuccess: (created) => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      navigate({ to: '/products/edit/$id', params: { id: String(created.id) } });
    },
  });

  return (
    <>
      <header className="toolbar">
        <h2 style={{ margin: 0 }}>New Product</h2>
        <span className="grow" />
        <Link to="/products">
          <button className="ghost">Cancel</button>
        </Link>
      </header>

      <div className="card">
        <ProductForm
          submitLabel="Create product"
          onSubmit={async (values, images) => {
            await finalize.mutateAsync({ values, images });
          }}
        />
      </div>

      {finalize.isError ? (
        <div className="toast">Create failed: {String(finalize.error)}</div>
      ) : null}
    </>
  );
}
